export default "__VITE_ASSET__CdNnAVvf__"